import { DataProvider } from "@refinedev/core";
import { API_CONFIG, getApiUrl, getFullApiUrl } from '../config/api';
import { authService } from './authProvider';

interface ApiResponse<T = any> {
  data?: T;
  error?: string;
}

export const typo3DataProvider: DataProvider = {
  getApiUrl: () => getFullApiUrl(),

  getList: async ({ resource, filters = [] }) => {
    try {
      // Auth-Check: Wenn nicht authentifiziert, leere Liste zurückgeben
      if (!authService.getIsAuthenticated()) {
        console.warn(`🔒 Not authenticated - returning empty list for ${resource}`);
        return {
          data: [],
          total: 0,
        };
      }

      // Use the new API_CONFIG for list endpoints
      let url: string;
      
      if (resource === 'users') {
        url = API_CONFIG.users.list();
      } else if (resource === 'guests') {
        url = API_CONFIG.guests.list();
      } else if (resource === 'invoices') {
        // Legacy v20_adverts documents
        url = API_CONFIG.invoices.list();
      } else if (resource === 'documents') {
        // New buchungsmanager_frontend documents
        url = API_CONFIG.documents.list();
      } else if (resource === 'senders') {
        url = API_CONFIG.senders.list();
      } else if (resource === 'templates') {
        url = API_CONFIG.templates.list();
      } else if (resource === 'additionalProducts') {
        // Spezielle Behandlung für additionalProducts
        url = getApiUrl('additionalProducts');
              } else if (resource === 'adverts') {
            // API-Aufruf für Adverts
            const baseUrl = `${window.location.origin}/?type=8847379247`;
            url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=getAllMyAdverts`;
        } else if (resource === 'standardprices') {
            // API-Aufruf für Standardpreise
            const baseUrl = `${window.location.origin}/?type=8847379247`;
            url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=getStandardPrices`;
        } else if (resource === 'taxsettings') {
            // API-Aufruf für Steuern & Gebühren
            const baseUrl = `${window.location.origin}/?type=8847379247`;
            url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=getTaxSettings`;
        } else if (resource === 'additionalprices') {
            // API-Aufruf für Zusatzleistungen
            const baseUrl = `${window.location.origin}/?type=8847379247`;
            url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=getAdditionalPrices`;
        } else if (resource === 'priceperiods') {
            // API-Aufruf für Zeitperioden
            const baseUrl = `${window.location.origin}/?type=8847379247`;
            url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=getPricePeriods`;
        } else if (resource === 'arrival-departure-rules') {
            // API-Aufruf für An-/Abreise-Regeln
            const baseUrl = `${window.location.origin}/?type=8847379247`;
            url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=arrival-departure-rules`;
      } else if (resource === 'tasklists') {
            // API-Aufruf für Aufgabenlisten
            const baseUrl = `${window.location.origin}/?type=8847379249`;
            url = `${baseUrl}&tx_buchungsmanagerfrontend_tasklistapi[controller]=TaskListApi&tx_buchungsmanagerfrontend_tasklistapi[action]=list`;
      } else if (resource === 'tasks') {
            // Tasks werden über die TaskList geladen
            url = getApiUrl('tasks');
      } else if (resource === 'comments') {
            // Comments werden über die Tasks geladen
            url = getApiUrl('comments');
      } else {
        // Fallback to direct API call
        url = getApiUrl(resource);
      }

      // Filter anwenden, insbesondere Suchfilter
      console.log(`📊 ${resource} - Filters received:`, filters);
      
      filters.forEach((filter: any) => {
        console.log(`🔍 Processing filter:`, filter);
        
        if ('field' in filter) {
          // Suchfilter für contains-Operator
          if (filter.operator === 'contains' && filter.value) {
            console.log(`✅ Adding search parameter: ${filter.value}`);
            url += `&tx_buchungsmanager_frontend[search]=${encodeURIComponent(filter.value)}`;
          }
          // Sender ID Filter
          else if (filter.field === 'sender_id' && filter.value) {
            console.log(`✅ Adding sender_id parameter: ${filter.value}`);
            url += `&tx_buchungsmanager_frontend[sender_id]=${encodeURIComponent(filter.value)}`;
          }
        }
      });

      console.log(`🔄 Fetching ${resource} list from:`, url);

      const response = await fetch(url, {
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      console.log(`✅ ${resource} list response:`, data);

      // Handle error responses
      if (data.error) {
        throw new Error(data.error);
      }

              // Handle different response formats
        let items = [];
        if (resource === 'adverts' && data.adverts) {
          // Special handling for adverts which returns {success: true, adverts: [...]}
          items = data.adverts;
        } else if (resource === 'standardprices' && data.standardPrices) {
          items = data.standardPrices;
        } else if ((resource === 'taxsettings' || resource === 'additionalprices' || resource === 'priceperiods' || resource === 'arrival-departure-rules') && data.data && Array.isArray(data.data)) {
          // Special handling for pricing resources and arrival-departure-rules which return {success: true, data: [...]}
          items = data.data;
        } else if (data.data && Array.isArray(data.data)) {
          // Generic data response format
          items = data.data;
        } else if (Array.isArray(data)) {
          items = data;
      }

      return {
        data: items,
        total: items.length,
      };
    } catch (error) {
      console.error(`❌ Error fetching ${resource} list:`, error);
      throw error;
    }
  },

  getOne: async ({ resource, id }) => {
    try {
      // Auth-Check
      if (!authService.getIsAuthenticated()) {
        throw new Error('Nicht authentifiziert');
      }

      // Use the new API_CONFIG for single item endpoints
      let url: string;
      
      if (resource === 'users' || resource === 'guests') {
        url = API_CONFIG.users.get(id.toString());
      } else if (resource === 'invoices') {
        // Legacy v20_adverts documents
        url = API_CONFIG.invoices.get(id.toString());
      } else if (resource === 'documents') {
        // New buchungsmanager_frontend documents
        url = API_CONFIG.documents.get(id.toString());
      } else if (resource === 'senders') {
        url = API_CONFIG.senders.get(id.toString());
      } else if (resource === 'templates') {
        url = API_CONFIG.templates.get(id.toString());
      } else if (resource === 'adverts') {
        // API-Aufruf für einzelnes Advert
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=advert&tx_buchungsmanager_frontend[id]=${id}`;
      } else if (resource === 'arrival-departure-rules') {
        // API-Aufruf für einzelne An-/Abreise-Regel
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=arrival-departure-rule&tx_buchungsmanager_frontend[id]=${id}`;
      } else if (resource === 'tasklists') {
        // API-Aufruf für einzelne TaskList mit Tasks
        const baseUrl = `${window.location.origin}/?type=8847379249`;
        url = `${baseUrl}&tx_buchungsmanagerfrontend_tasklistapi[controller]=TaskListApi&tx_buchungsmanagerfrontend_tasklistapi[action]=show&tx_buchungsmanagerfrontend_tasklistapi[uid]=${id}&tx_buchungsmanagerfrontend_tasklistapi[includeTasks]=1`;
      } else {
        // Fallback
        url = getApiUrl(resource, 'user', id.toString());
      }

      console.log(`🔄 Fetching ${resource} item ${id} from:`, url);

      const response = await fetch(url, {
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const apiResponse: ApiResponse = await response.json();
      
      console.log(`✅ ${resource} item response:`, apiResponse);

      if (apiResponse.error) {
        throw new Error(apiResponse.error);
      }

      return { data: apiResponse.data || apiResponse };
    } catch (error) {
      console.error(`❌ Error fetching ${resource} item ${id}:`, error);
      throw error;
    }
  },

  create: async ({ resource, variables }) => {
    try {
      // Auth-Check
      if (!authService.getIsAuthenticated()) {
        throw new Error('Nicht authentifiziert');
      }

      // Use the new API_CONFIG for create endpoints
      let url: string;
      let body: any;
      
      if (resource === 'users') {
        url = API_CONFIG.users.create();
      } else if (resource === 'guests') {
        url = API_CONFIG.guests.create();
      } else if (resource === 'invoices') {
        // Legacy v20_adverts documents
        url = API_CONFIG.invoices.create();
      } else if (resource === 'documents') {
        // New buchungsmanager_frontend documents
        url = API_CONFIG.documents.create();
      } else if (resource === 'senders') {
        url = API_CONFIG.senders.create();
      } else if (resource === 'templates') {
        url = API_CONFIG.templates.create();
      } else if (resource === 'standardprices') {
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=createStandardPrice`;
      } else if (resource === 'taxsettings') {
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=createTaxSetting`;
      } else if (resource === 'additionalprices') {
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=createAdditionalPrice`;
      } else if (resource === 'priceperiods') {
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=createPricePeriod`;
      } else if (resource === 'arrival-departure-rules') {
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=create-arrival-departure-rule`;
      } else if (resource === 'adverts') {
        // API-Aufruf für Advert erstellen
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=createAdvert`;
        body = variables;
      } else if (resource === 'tasklists') {
        // API-Aufruf für TaskList erstellen
        const baseUrl = `${window.location.origin}/?type=8847379249`;
        url = `${baseUrl}&tx_buchungsmanagerfrontend_tasklistapi[controller]=TaskListApi&tx_buchungsmanagerfrontend_tasklistapi[action]=create`;
        body = variables;
      } else if (resource === 'tasks') {
        // API-Aufruf für Task erstellen
        const baseUrl = `${window.location.origin}/?type=8847379249`;
        url = `${baseUrl}&tx_buchungsmanagerfrontend_tasklistapi[controller]=TaskListApi&tx_buchungsmanagerfrontend_tasklistapi[action]=createTask&tx_buchungsmanagerfrontend_tasklistapi[taskListUid]=${variables.tasklist}`;
        body = variables;
      } else if (resource === 'comments') {
        // API-Aufruf für Comment erstellen
        const baseUrl = `${window.location.origin}/?type=8847379249`;
        url = `${baseUrl}&tx_buchungsmanagerfrontend_tasklistapi[controller]=TaskListApi&tx_buchungsmanagerfrontend_tasklistapi[action]=createComment&tx_buchungsmanagerfrontend_tasklistapi[taskUid]=${variables.task}`;
        body = variables;
      } else {
        url = getApiUrl(resource, 'createUser');
      }

      console.log(`🔄 Creating ${resource} at:`, url, 'with data:', variables);

      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body || variables),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const apiResponse: ApiResponse = await response.json();
      
      console.log(`✅ ${resource} create response:`, apiResponse);

      if (apiResponse.error) {
        throw new Error(apiResponse.error);
      }

      return { data: apiResponse.data || apiResponse };
    } catch (error) {
      console.error(`❌ Error creating ${resource}:`, error);
      throw error;
    }
  },

  update: async ({ resource, id, variables }) => {
    try {
      // Auth-Check
      if (!authService.getIsAuthenticated()) {
        throw new Error('Nicht authentifiziert');
      }

      // Use the new API_CONFIG for update endpoints
      let url: string;
      
      if (resource === 'users') {
        url = API_CONFIG.users.update(id.toString());
      } else if (resource === 'guests') {
        url = API_CONFIG.guests.update(id.toString());
      } else if (resource === 'invoices') {
        // Legacy v20_adverts documents
        url = API_CONFIG.invoices.update(id.toString());
      } else if (resource === 'documents') {
        // New buchungsmanager_frontend documents
        url = API_CONFIG.documents.update(id.toString());
      } else if (resource === 'senders') {
        url = API_CONFIG.senders.update(id.toString());
      } else if (resource === 'templates') {
        url = API_CONFIG.templates.update(id.toString());
      } else if (resource === 'standardprices') {
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=updateStandardPrice&tx_buchungsmanager_frontend[id]=${id}`;
      } else if (resource === 'taxsettings') {
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=updateTaxSetting&tx_buchungsmanager_frontend[id]=${id}`;
      } else if (resource === 'additionalprices') {
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=updateAdditionalPrice&tx_buchungsmanager_frontend[id]=${id}`;
      } else if (resource === 'priceperiods') {
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=updatePricePeriod&tx_buchungsmanager_frontend[id]=${id}`;
      } else if (resource === 'arrival-departure-rules') {
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=update-arrival-departure-rule&tx_buchungsmanager_frontend[id]=${id}`;
      } else if (resource === 'adverts') {
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=updateAdvert&tx_buchungsmanager_frontend[id]=${id}`;
      } else if (resource === 'tasklists') {
        const baseUrl = `${window.location.origin}/?type=8847379249`;
        url = `${baseUrl}&tx_buchungsmanagerfrontend_tasklistapi[controller]=TaskListApi&tx_buchungsmanagerfrontend_tasklistapi[action]=update&tx_buchungsmanagerfrontend_tasklistapi[uid]=${id}`;
      } else if (resource === 'tasks') {
        const baseUrl = `${window.location.origin}/?type=8847379249`;
        url = `${baseUrl}&tx_buchungsmanagerfrontend_tasklistapi[controller]=TaskListApi&tx_buchungsmanagerfrontend_tasklistapi[action]=updateTask&tx_buchungsmanagerfrontend_tasklistapi[uid]=${id}`;
      } else {
        url = getApiUrl(resource, 'updateUser', id.toString());
      }

      console.log(`🔄 Updating ${resource} ${id} at:`, url, 'with data:', variables);

      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(variables),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const apiResponse: ApiResponse = await response.json();
      
      console.log(`✅ ${resource} update response:`, apiResponse);

      if (apiResponse.error) {
        throw new Error(apiResponse.error);
      }

      return { data: apiResponse.data || apiResponse };
    } catch (error) {
      console.error(`❌ Error updating ${resource} ${id}:`, error);
      throw error;
    }
  },

  deleteOne: async ({ resource, id }) => {
    try {
      // Auth-Check
      if (!authService.getIsAuthenticated()) {
        throw new Error('Nicht authentifiziert');
      }

      // Use the new API_CONFIG for delete endpoints (if available)
      let url: string;
      
      if (resource === 'users' || resource === 'guests') {
        url = API_CONFIG.users.delete(id.toString());
      } else if (resource === 'invoices' || resource === 'documents') {
        url = API_CONFIG.invoices.delete(id.toString());
      } else if (resource === 'senders') {
        url = API_CONFIG.senders.delete(id.toString());
      } else if (resource === 'templates') {
        url = API_CONFIG.templates.delete(id.toString());
      } else if (resource === 'standardprices') {
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=deleteStandardPrice&tx_buchungsmanager_frontend[id]=${id}`;
      } else if (resource === 'taxsettings') {
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=deleteTaxSetting&tx_buchungsmanager_frontend[id]=${id}`;
      } else if (resource === 'additionalprices') {
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=deleteAdditionalPrice&tx_buchungsmanager_frontend[id]=${id}`;
      } else if (resource === 'priceperiods') {
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=deletePricePeriod&tx_buchungsmanager_frontend[id]=${id}`;
      } else if (resource === 'arrival-departure-rules') {
        const baseUrl = `${window.location.origin}/?type=8847379247`;
        url = `${baseUrl}&tx_buchungsmanager_frontend[controller]=RestApi&tx_buchungsmanager_frontend[action]=delete-arrival-departure-rule&tx_buchungsmanager_frontend[id]=${id}`;
      } else if (resource === 'tasklists') {
        const baseUrl = `${window.location.origin}/?type=8847379249`;
        url = `${baseUrl}&tx_buchungsmanagerfrontend_tasklistapi[controller]=TaskListApi&tx_buchungsmanagerfrontend_tasklistapi[action]=delete&tx_buchungsmanagerfrontend_tasklistapi[uid]=${id}`;
      } else if (resource === 'tasks') {
        const baseUrl = `${window.location.origin}/?type=8847379249`;
        url = `${baseUrl}&tx_buchungsmanagerfrontend_tasklistapi[controller]=TaskListApi&tx_buchungsmanagerfrontend_tasklistapi[action]=deleteTask&tx_buchungsmanagerfrontend_tasklistapi[uid]=${id}`;
      } else {
        url = getApiUrl(resource, 'deleteUser', id.toString());
      }

      console.log(`🔄 Deleting ${resource} ${id} at:`, url);

      // TYPO3 custom actions always use POST
      const usePost = ['standardprices', 'taxsettings', 'additionalprices', 'priceperiods', 'arrival-departure-rules', 'adverts', 'tasklists', 'tasks'].includes(resource);

      const response = await fetch(url, {
        method: usePost ? 'POST' : 'DELETE',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: usePost ? JSON.stringify({}) : undefined,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const apiResponse: ApiResponse = await response.json();
      
      console.log(`✅ ${resource} delete response:`, apiResponse);

      if (apiResponse.error) {
        throw new Error(apiResponse.error);
      }

      return { data: apiResponse.data || apiResponse };
    } catch (error) {
      console.error(`❌ Error deleting ${resource} ${id}:`, error);
      throw error;
    }
  },

  getMany: async ({ resource, ids }) => {
    // For now, fetch items individually
    const promises = ids.map(id => typo3DataProvider.getOne!({ resource, id }));
    const results = await Promise.all(promises);
    
    return {
      data: results.map((result: any) => result.data) as any[],
    };
  },

  custom: async ({ url, method, filters, sorters, payload, query, headers }) => {
    try {
      console.log(`🔧 Custom API request:`, { url, method, query });
      
      // Build the full URL with query parameters if provided
      let fullUrl = url.startsWith('http') ? url : `${getFullApiUrl()}${url}`;
      
      if (query && Object.keys(query).length > 0) {
        const queryString = new URLSearchParams(query).toString();
        fullUrl += `?${queryString}`;
      }
      
      const requestOptions: RequestInit = {
        method: method?.toUpperCase() || 'GET',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          ...headers,
        },
      };
      
      if (payload && method !== 'get') {
        requestOptions.body = JSON.stringify(payload);
      }
      
      const response = await fetch(fullUrl, requestOptions);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log(`✅ Custom API response:`, data);
      
      return { data };
    } catch (error) {
      console.error(`❌ Custom API error:`, error);
      throw error;
    }
  },
}; 